import { Grid, Card, Paper, Container, Typography } from "@mui/material";
import { Header, HeaderActionType, LoadingWrapper, SmallerHeader } from "ui";
import { useQuery } from "@apollo/client";
import { GET_COMPANY_STATS } from "../../features/graphql/query";
import usePersonStore from "../store/personStore";
import StaffProgressTable from "./components/StaffComponents/StaffProgressTable";
import { People } from "@mui/icons-material";

export default function CompanyStatsPage({ onBack }: { onBack: () => void }) {

    return (
        <LoadingWrapper loading={false}>
            {/* <Typography>Put option to reassign/rearrange people</Typography> */}

            <Card elevation={4} style={{ width: "100%", display: "flex", height: "auto" }}>
                <StaffProgressTable onBack={onBack} />
            </Card>
        </LoadingWrapper>
    )
}